import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { Logo } from "../components/logo";
import { publicGroupsApi } from "../lib/api";
import { errorMessage } from "../lib/session";

/**
 * Behind the unsubscribe link of a mail sent on someone else's behalf. A button, not an
 * automatic call on load: mail scanners open every link, and must not unsubscribe anyone.
 */
export const Route = createFileRoute("/desabonnement")({
  validateSearch: (search: Record<string, unknown>): { t?: string } => ({
    t: typeof search.t === "string" ? search.t : undefined,
  }),
  component: UnsubscribePage,
});

function UnsubscribePage() {
  const { t } = Route.useSearch();
  const unsubscribe = useMutation({ mutationFn: () => publicGroupsApi.unsubscribe(t ?? "") });

  return (
    <main className="mx-auto grid max-w-md gap-6 px-4 py-16">
      <Logo />
      {unsubscribe.isSuccess ? (
        <>
          <h1 className="text-4xl font-semibold">C'est fait</h1>
          <p className="text-lg text-muted">
            Vous ne recevrez plus de messages envoyés de la part d'autres personnes (tirages,
            rappels). Les e-mails que vous demandez vous-même, comme un code de connexion,
            continuent d'arriver.
          </p>
        </>
      ) : (
        <>
          <h1 className="text-4xl font-semibold">Ne plus recevoir ces messages ?</h1>
          <p className="text-lg text-muted">
            Plus aucun Secret Santa ni rappel envoyé par quelqu'un d'autre n'arrivera à cette
            adresse.
          </p>
          {unsubscribe.isError && (
            <p className="text-danger">
              {errorMessage(unsubscribe.error, "Ce lien ne marche pas.")}
            </p>
          )}
          <button
            type="button"
            className="btn justify-self-start"
            disabled={!t || unsubscribe.isPending}
            onClick={() => unsubscribe.mutate()}
          >
            Me désabonner
          </button>
        </>
      )}
    </main>
  );
}
